// extracted by mini-css-extract-plugin
export default {"svg":"LoadingCircle_svg__-YyKi","rotate4":"LoadingCircle_rotate4__XXnf0","circle":"LoadingCircle_circle__l3k5l","dash4":"LoadingCircle_dash4__tOX3Q"};